import LandScreen from "components/land-screen/land-screen";

export default LandScreen;
